import React from 'react';

import ConversationPane from './ConversationPane';

interface ConversationPaneContainerProps {
  isChatVisible: boolean;
  isLoading: boolean;
  onChatLoad: () => void;
  onCloseChat: () => void;
  onMoxoSubmitError: (error: string) => void;
  onMoxoSubmitSuccess: () => void;
  onToggleMinimize: () => void;
}

const ConversationPaneContainer = ({
  isChatVisible,
  isLoading,
  onChatLoad,
  onCloseChat,
  onMoxoSubmitError,
  onMoxoSubmitSuccess,
}: ConversationPaneContainerProps) => {
  return (
    <ConversationPane
      isChatVisible={isChatVisible}
      isLoading={isLoading}
      onChatLoad={onChatLoad}
      onCloseChat={onCloseChat}
      onMoxoSubmitError={onMoxoSubmitError}
      onMoxoSubmitSuccess={onMoxoSubmitSuccess}
    />
  );
};

export default ConversationPaneContainer;